import * as React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';

const StyledButton = styled(Button)({
  fontWeight: 'normal',
  borderRadius: '3px',
  textTransform: 'none',
  lineHeight: 'normal'
});

export const ProtrakButton = ({
  buttonText,
  onClick,
  disabled,
  variant = 'contained',
  backgroundColor,
  style,
  icon,
  autoFocus = true
}) => {
  return (
    <StyledButton
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      autoFocus={autoFocus}
      sx={style}
      color={backgroundColor}
      disableRipple
      disableElevation={true}
    >
      {icon ? icon : null}
      {buttonText}
    </StyledButton>
  );
};
